export default __webpack_public_path__ + "static/media/Big_Query_Github.c63c0a46.png";